<template>
  <b-modal id="promisePrescriptModal" :title="title" size="lg">
    <div class="details" id="printArea" ref="printRef">
      <div class="details_box">
        <div class="print_table">
          <table>
            <colgroup>
              <col width="200px" />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th class="fwb"><span>코끼리 원외탕전실</span></th>
                <td class="ac fwb" colspan="100%">
                  <span>약속처방 작업일지</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="print_table">
          <table>
            <colgroup>
              <col width="200px" />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th class="fwb"><span>처방기관</span></th>
                <td class="fwb" colspan="3">
                  <span>{{pharmacyInfo.clinic_nm}} {{pharmacyInfo.doctor_nm}}</span>
                </td>
                <th><span>주문번호</span></th>
                <td colspan="5"><span>{{pharmacyInfo.order_code}}</span></td>
              </tr>
              <tr>
                <th class="fwb"><span>환자명</span></th>
                <td class="fwb" colspan="3">
                  <span>{{pharmacyInfo.patient_nm}}</span>
                </td>
                <th><span>조제일</span></th>
                <td class="fwb" colspan="5"><span>{{pharmacyInfo.currentDay}}</span></td>
              </tr>
              <tr>
                <th><span>주문정보</span></th>
                <td colspan="3"><span>약속상품</span></td>
                <th><span>조제자</span></th>
                <td colspan="5"><span>김봉준</span></td>
              </tr>
              <tr>
                <th><span>배송정보</span></th>
                <td colspan="3"><span>{{pharmacyInfo.delivery_type_nm}}</span></td>
                <th><span>발송일자</span></th>
                <td colspan="5"><span>{{pharmacyInfo.currentDay}}</span></td>
              </tr>
              <tr>
                <th><span>보내는 주소</span></th>
                <td colspan="100%">
                  <span>[{{pharmacyInfo.send_post_no}}] {{pharmacyInfo.send_addr}} {{pharmacyInfo.send_addr_dtl}}</span>
                </td>
              </tr>
              <tr>
                <th><span>받는 주소</span></th>
                <td colspan="100%">
                  <span>[{{pharmacyInfo.receive_post_no}}] {{pharmacyInfo.receive_addr}} {{pharmacyInfo.receive_addr_dtl}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="print_table">
          <table>
            <caption style="caption-side: top">
              2. 주문 내역
            </caption>
            <colgroup>
              <col width="200px" />
              <col width="*" />
            </colgroup>
            <tbody>
            <tr>
              <th class="fwb"><span>약속상품명</span></th>
              <td class="fwb" colspan="100%">
                <span>{{pharmacyInfo.prescribe_nm}}</span>
              </td>
            </tr>
            <tr>
              <th class="fwb"><span>구매수량</span></th>
              <td class="fwb" colspan="100%">
                <span>{{pharmacyInfo.item_quantity}}</span>
              </td>
            </tr>
            <tr>
              <th class="fwb"><span>복용법</span></th>
              <td class="fwb" colspan="100%">
                <span v-if="pharmacyInfo.howtake_attach_yn == 'Y'" class="font_blue">포함</span>
                <span v-else>미포함</span>
              </td>
            </tr>
            <tr>
              <th class="fwb"><span>사향인증서</span></th>
              <td class="fwb" colspan="100%">
                <span v-if="pharmacyInfo.musk_certificate_attach_yn == 'Y'" class="font_blue">포함</span>
                <span v-else>미포함</span>
              </td>
            </tr>
            <tr>
              <th class="fwb"><span>10환 상자셋트</span></th>
              <td class="fwb" colspan="100%">
                <span v-if="pharmacyInfo.gjd_set_yn == 'Y'" class="font_blue">포함</span>
                <span v-else>선택안함</span>
              </td>
            </tr>
            <tr>
              <th class="fwb"><span>공진단 종이가방</span></th>
              <td class="fwb" colspan="100%">
                <span v-if="pharmacyInfo.gjd_gift_bag_yn == 'Y'" class="font_blue">포함</span>
                <span v-else>선택안함</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="print_table">
          <table>
            <caption style="caption-side: top">
              3. 요구사항
            </caption>
            <tbody>
              <tr>
                  <td colspan="100%" class="minHeight"><span class="img font_blue">{{pharmacyInfo.wrapper_req}}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="print_table" v-if="pharmacyInfo.is_combined == 'Y'">
          <table>
            <caption style="caption-side: top">
              4. 묶음배송정보
            </caption>
            <tbody>
              <tr>
                  <td colspan="100%" class="minHeight"><span class="img font_red">{{pharmacyInfo.combined_order_code_list}} 주문 묶음배송 처리 요망</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <template #modal-footer>
      <b-button class="btn btn_md btn_darkblue" @click="print">출력</b-button>
    </template>
  </b-modal>
</template>

<script>
import axios from 'axios'
import printJS from 'print-js'
import commonUtil from "@/mixin/commonUtil";

export default {
  name: 'promisePrescriptModal',
  mixins: [commonUtil],
  props: {
    title: String,
    prescribe_seq : Number
  },
  data() {
    return {
      prescribeSeq : this.prescribe_seq,
      pharmacyInfo : {},
      cumulative : 0,
    }
  },
  watch : {
    // eslint-disable-next-line no-mixed-spaces-and-tabs
    prescribe_seq(newValue) {
      console.log("변경 체크");
      //props 변경 여부 확인
      this.prescribeSeq = newValue;
      this.fn_search_prescribe();

    }
  },
  mounted() {
    //this.popList = this.splitData(this.printItemList, 14);
    console.log(this.popList);
  },
  methods: {
    print() {
      // this.$print(this.$refs.printRef);

      printJS({
        type: 'html',
        printable: 'printArea',
        showModal: true,
        targetStyles: ['*'],
        style: `
                            @media print {
                            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
                            td.highlight-span span { background-color: #e0dcdc!important; }
                            }
                        `
        //onPrintDialogClose : () => {alert("@@@@@34444");}
      })
    },
    splitData(arr, num) {
      const result = [];
      for (let i = 0; i < arr.length; i += num) {
        let tempArray;
        tempArray = arr.slice(i, i + num);
        result.push(tempArray);
      }
      return result;
    },
    // 처방정보 조회
    fn_search_prescribe(){

      this.prescribeSeq = this.prescribe_seq;
      console.log("@@@ this.prescribeSeq : %o",this.prescribeSeq);
      let param = new Object();
      param.prescribe_seq = this.prescribe_seq;

      console.log("@@@ param : %o",param);

      axios
          .post("/api/admin/work/getPromisePharmacyInfo", param)
          .then((res) => {
            console.log("@@@@ res : %o",res);
            this.pharmacyInfo = res.data.pharmacyInfo;

            //조제일 구하기 : 출력날짜
            this.fn_get_date();

          })
          .catch((err) => console.log(err));
    },
    fn_get_date(){
      const now = new Date();
      const year = now.getFullYear();
      let month = now.getMonth() + 1;
      if(month < 10){
        month = "0"+month;
      }

      const day = now.getDate();

      this.pharmacyInfo.currentDay = year+"-"+month+"-"+day;
    },
  },
};
</script>

<style lang="scss" scope>
@page {
  size: A4;
}

@media print {
  * {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
    background-color: #fff !important;
  }
}
</style>
